// extracted by mini-css-extract-plugin
module.exports = {"pc-com":"PCCom_pc-com__d2Rfa"};